export var MovieLanguageEnum;
(function (MovieLanguageEnum) {
    MovieLanguageEnum["Eng"] = "ENG";
    MovieLanguageEnum["Rus"] = "RUS";
    MovieLanguageEnum["Geo"] = "GEO";
})(MovieLanguageEnum || (MovieLanguageEnum = {}));
export var MPAARating;
(function (MPAARating) {
    MPAARating["G"] = "G";
    MPAARating["PG"] = "PG";
    MPAARating["PG13"] = "PG-13";
    MPAARating["R"] = "R";
})(MPAARating || (MPAARating = {}));
export var MovieStatusEnum;
(function (MovieStatusEnum) {
    MovieStatusEnum["AV"] = "AV";
    MovieStatusEnum["CS"] = "CS";
    MovieStatusEnum["HI"] = "HI";
})(MovieStatusEnum || (MovieStatusEnum = {}));
export var MovieTypeEnum;
(function (MovieTypeEnum) {
    MovieTypeEnum["Avod"] = "AVOD";
    MovieTypeEnum["Est"] = "EST";
    MovieTypeEnum["Svod"] = "SVOD";
})(MovieTypeEnum || (MovieTypeEnum = {}));
export var MoviesTypeEnum;
(function (MoviesTypeEnum) {
    MoviesTypeEnum["Movie"] = "movie";
    MoviesTypeEnum["Series"] = "series";
})(MoviesTypeEnum || (MoviesTypeEnum = {}));
export var MovieDistributorsEnum;
(function (MovieDistributorsEnum) {
    MovieDistributorsEnum["Amedia"] = "amedia";
})(MovieDistributorsEnum || (MovieDistributorsEnum = {}));



//////////////////
// WEBPACK FOOTER
// ./src/types/Movie.ts
// module id = 48
// module chunks = 1